module.exports = __webpack_public_path__ + "static/media/logo_yakada.ccf7741c.png";